module.exports = "/images/vendor/desiigner-svg/svg/logoipsum/logoipsum-10.svg?893ee9607f7218addc61167a2adb3659";